import React, { Component } from "react";
import { browserHistory } from "react-router";
import { FlatButton, Dialog, CircularProgress } from "material-ui";
import firebase from "../firebase";

export default class Claim extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  componentWillMount() {
    const { location } = this.props;
    this.restaurantId = this.props.params && this.props.params.restaurantId;
    const query = location && location.query;

    this.code = query && query.claimCode;

    if (!this.code || !this.restaurantId) {
      return browserHistory.push("/");
    }
  }

  render() {
    const errorActions = [
      <FlatButton label="Ok" primary={true} onClick={this.handleClose} />,
    ];
    const actions = [
      <FlatButton
        label="Cancel"
        primary={true}
        onClick={this.handleClose}
        disabled={this.state.loading}
      />,
      <FlatButton
        label="Accept"
        primary={true}
        keyboardFocused={true}
        disabled={this.state.loading}
        onClick={this.handleClaim}
      />,
    ];
    let content;

    if (this.state.loading) {
      content = <CircularProgress />;
    } else if (this.state.error) {
      content = this.state.error;
    } else {
      content =
        "Claiming this restaurant allows you to manage your menu, print QR Codes, and customize the user experience for your customers.";
    }

    return (
      <Dialog
        title="Claim Restaurant"
        actions={this.state.error ? errorActions : actions}
        modal={false}
        open
        onRequestClose={this.handleClose}
      >
        {content}
      </Dialog>
    );
  }

  handleClaim = () => {
    this.setState({
      loading: true,
    });
    const claimFunction = firebase.functions().httpsCallable("claim");
    claimFunction({
      code: this.code,
      restaurantId: this.restaurantId,
    })
      .then(() => {
        browserHistory.push(`/${this.restaurantId}`);
      })
      .catch((error) => {
        this.setState({
          loading: false,
          error:
            "Error claiming restaurant. Please contact us at hello@chowreach.com",
        });
      });
  };

  handleClose = () => {
    browserHistory.push("/");
  };
}



// WEBPACK FOOTER //
// ./src/pages/Claim.js